import { forwardRef } from 'react'
import { useToggleButton } from '@react-aria/button'
import cx from 'classnames'
import { useObjectRef } from 'utils/useObjectRef'

import Styles from './CardButton.module.scss'
import { CardButtonProps } from './Types'
import { useToggleState } from '@react-stately/toggle'

export const CardButton = forwardRef<HTMLButtonElement, CardButtonProps>((props, forwardedRef) => {
  const {
    label,
    subLabel,
    media,
    icon,
    variant = 'vertical',
    maxContentWidth = '100%',
    labelSize = 'sm',
    className,
    labelClassName,
    ...otherProps
  } = props
  const ref = useObjectRef<HTMLButtonElement>(forwardedRef)

  const state = useToggleState(otherProps)
  const { buttonProps, isPressed } = useToggleButton(otherProps, state, ref)

  return (
    <button
      {...buttonProps}
      ref={ref}
      type="button"
      className={cx(Styles.cardButton, Styles[variant], Styles[labelSize], className, {
        [Styles.pressed]: isPressed,
        [Styles.disabled]: buttonProps.disabled,
        [Styles.selected]: state.isSelected,
      })}
    >
      <div className={Styles.content} style={{ maxWidth: maxContentWidth }}>
        <span className={cx(Styles.label, labelClassName)}>{label}</span>
        {subLabel && <span className={Styles.subLabel}>{subLabel}</span>}
      </div>
      {icon && <div className={Styles.icon}>{icon}</div>}
      <div className={Styles.media}>{media}</div>
    </button>
  )
})

CardButton.displayName = 'CardButton'

export default CardButton
